import { useState, useRef, useMemo, useEffect } from "react";
import { useRecorderUtils } from "./RecorderElement";
export function useRecorderEventCallback(action) {
    var recorderElement = useRecorderUtils();
    var _a = useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = useRef(null);
    var memoizedAction = useMemo(function () { return action; }, [action]);
    useEffect(function () {
        var _a;
        if (!(recorderElement === null || recorderElement === void 0 ? void 0 : recorderElement.on))
            return;
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = (_a = recorderElement === null || recorderElement === void 0 ? void 0 : recorderElement.on(memoizedAction)) === null || _a === void 0 ? void 0 : _a.subscribe(function (data) {
            setData(data);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [recorderElement === null || recorderElement === void 0 ? void 0 : recorderElement.on, memoizedAction]);
    return data;
}
